export default __webpack_public_path__ + "static/media/blog-img2.dbe35015.jpg";